// extracted by mini-css-extract-plugin
export default {"MUIRoot":"MediaGrid_MUIRoot__V5iiC","GridWrapper":"MediaGrid_GridWrapper__qOtJo"};